import { useEffect, useState, useTransition } from "react";
import apiService from "../services/api-service";
import { KCTEventDto } from "../types/contracts";

export const useFetchCurrentEvent = () => {
  const [event, setEvent] = useState<KCTEventDto | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await apiService.getCurrentEvent<KCTEventDto>();
        const data = response.data;

        startTransition(() => {
          setEvent(data);
        });
      } catch (err) {
        setError(err as Error);
        console.error("Error loading event from API:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvent();
  }, []);

  return { event, isLoading, isPending, error, setEvent };
};
